module.exports = __webpack_public_path__ + "static/media/29ADMSPC20.70d5844b.jpg";